import { setErrors } from './helpers';
import { postData, putData } from './fetch';

window.addEventListener('load', () => {
  const emailInput = document.querySelector('.email-input');
  const emailHiddenInput = document.querySelector('.hidden-email-input');
  const emailInputWrapper = document.querySelector('.email-input-wrapper');
  const message = document.querySelector('.message');
  const submitBtn = document.querySelector('.form-submit');
  const questionForm = document.querySelector('.question-form');
  const questionPopupWrapper = document.querySelector(
    '.question-popup-wrapper',
  );
  const questionPopupSuccessWrapper = document.querySelector(
    '.question-popup-success-wrapper',
  );
  const questionErrorsList = document.querySelector('.question-errors');
  const emailErrorsList = document.querySelector('.email-errors');
  const emailNotification = document.querySelector('.email-notification');
  const emailCheckboxWrapper = document.querySelector(
    '.question-form .checkbox',
  );
  const emailCheckbox = document.querySelector(
    '.question-form .checkbox input',
  );

  let emailValid = false;

  if (emailHiddenInput) {
    emailValid = true;
  }

  if (questionForm) {
    questionForm.addEventListener('input', () => {
      if (emailValid && message.value) {
        submitBtn.removeAttribute('disabled');
      } else {
        submitBtn.setAttribute('disabled', 'disabled');
      }
    });

    questionForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      submitBtn.value = 'Загрузка...';
      submitBtn.setAttribute('disabled', 'disabled');

      if (questionPopupWrapper) {
        const body = {
          question: message.value,
        };

        if (emailHiddenInput) {
          body.email = emailHiddenInput.value;
        } else {
          body.email = emailInput.value;
        }

        const response = await postData('/questions/send', body);

        if (response) {
          if (response.statusCode === 200) {
            questionPopupWrapper.classList.remove('active');
            questionForm.reset();
            submitBtn.setAttribute('disabled', 'disabled');
            submitBtn.value = 'Отправить';
            emailNotification.classList.remove('visible');

            if (questionPopupSuccessWrapper) {
              questionPopupSuccessWrapper.classList.add('active');
            }
          } else {
            submitBtn.removeAttribute('disabled');
            submitBtn.value = 'Отправить';

            if (response.errors && response.errors.email) {
              setErrors(emailErrorsList, response.errors.email);
            }

            if (response.errors && response.errors.question) {
              setErrors(questionErrorsList, response.errors.question);
            }
          }
        }

        if (emailInput && emailInput.value) {
          const userBody = {
            email: emailInput.value,
            promoEmailsSubscribed: emailCheckbox.checked,
          };

          await putData('/profile/information', userBody);
        }
      }
    });
  }

  if (emailInput) {
    emailInput.addEventListener('input', (e) => {
      const emailIsValid = /.+@.+\..+/gi.test(e.target.value);

      if (!emailIsValid) {
        emailValid = false;

        if (emailInputWrapper) {
          emailInputWrapper.classList.add('error');
        }
      } else {
        emailValid = true;

        if (emailInputWrapper) {
          emailInputWrapper.classList.remove('error');
        }

        if (emailNotification) {
          emailNotification.classList.add('visible');
        }

        if (emailCheckboxWrapper) {
          emailCheckboxWrapper.classList.add('visible');
        }
      }
    });
  }
});
